(ns frontend.test.number-input.view
  (:require
   [frontend.test.number-input.event :as event]
   [frontend.test.number-input.sub :as sub]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.components.input.currency :as currency-input]
   [ui.components.input.integer :as integer-input]
   [ui.components.input.number :as number-input]
   [ui.components.input.percentage :as percentage-input]
   [ui.components.text.view :as text]
   [ui.dom-globals :as dg]))

(defn random-int
  []
  (let [random-fraction (rand)
        random-number (int (+ (* random-fraction (- 100000 1)) 1))]
    random-number))

(defn random-float
  []
  (let [min 1.0
        max 10.0
        decimal-places 5
        random-fraction (rand)
        scale (Math/pow 10.0 decimal-places)
        random-number (* (+ (* random-fraction (- max min)) min) scale)]
    (/ (int random-number) scale)))

(defn min-max-decimals
  []
  (let [min-decimals @(rf/subscribe [::sub/min-decimals])
        max-decimals @(rf/subscribe [::sub/max-decimals])]
    [:div
     [:div
      [:div
       [:label "Min decimals"]
       [number-input/view
        {:value     min-decimals
         :on-change #(rf/dispatch [::event/set-min-decimals %])}]]

      [:div
       [:label "Max decimals"]
       [number-input/view
        {:value     max-decimals
         :on-change #(rf/dispatch [::event/set-max-decimals %])}]]]]))

(defn external-change-simulation
  []
  (let [state (r/atom {:interval nil
                       :running? false})
        start-interval (fn []
                         (let [interval (js/setInterval
                                         (fn []
                                           (let [int-value (random-int)
                                                 float-value (random-float)]
                                             (rf/dispatch [::event/on-change-integer int-value])
                                             (rf/dispatch [::event/on-change-float float-value])))
                                         2000)]
                           (swap! state assoc
                                  :interval interval
                                  :running? true)))

        stop-interval (fn []
                        (let [prev-interval (:interval @state)]
                          (when prev-interval
                            (js/clearInterval prev-interval))
                          (swap! state assoc
                                 :interval nil
                                 :running? false)))]
    (r/create-class
     {:component-will-unmount (fn []
                                (stop-interval))
      :reagent-render
      (fn []
        (let [running? (:running? @state)
              integer-value @(rf/subscribe [::sub/integer-value])
              float-value @(rf/subscribe [::sub/float-value])]
          [:div
           [text/p "Simulate external changes"]

           [text/p (str "Integer value: " integer-value)]
           [text/p (str "Decimal value: " float-value)]


           (if running?
             [button/secondary-hollow
              {:on-click stop-interval}
              "Stop interval"]
             [button/primary-solid
              {:on-click start-interval}
              "Start changes interval"])
           ]))})))

(defn with-multiplier
  []
  (let [state (r/atom {:int-value   nil
                       :float-value nil})]
    (fn []
      [:div
       [:div
        {:class "w-full h-full flex flex-1 flex-col gap-2 p-2"}
        [:label
         {:for :integer-with-multiplier}
         "Integer with 10x multiplier"]

        [integer-input/view
         {:id         :integer-with-multiplier
          :value      (:int-value @state)
          :multiplier 10
          :on-change  (fn [new-value]
                        (swap! state assoc :int-value new-value))}]]

       [:div
        {:class "w-full h-full flex flex-1 flex-col gap-2 p-2"}
        [:label
         {:for :decimal-with-multiplier}
         "Decimal with 2x multiplier"]

        [number-input/view
         {:id         :decimal-with-multiplier
          :value      (:float-value @state)
          :multiplier 2
          :on-change  (fn [new-value]
                        (swap! state assoc :float-value new-value))}]]])))

(def multiplier-options
  [{:value "1"
    :label "No multiplier"}
   {:value "k"
    :label "k/K"}
   {:value "M"
    :label "m/M"}
   {:value "Lacs"
    :label "Lacs"}
   {:value "Cr"
    :label "Cr"}])

(defn different-multiplier
  []
  (let [state-atom (r/atom {:float-value nil
                            :int-value   nil
                            :multiplier  nil})]
    (fn []
      (let [float-value (:float-value @state-atom)
            int-value (:int-value @state-atom)
            multiplier (:multiplier @state-atom)]
        [:div
         [text/h2 "Multiplier"]

         [:div
          {:class "w-full h-full flex flex-1 flex-col gap-2 p-2"}
          [:label
           {:for :decimal-with-multiplier}
           "Decimal with multiplier"]
          [number-input/view
           {:id         :decimal-with-multiplier
            :value      float-value
            :multiplier multiplier
            :on-change  (fn [value]
                          (swap! state-atom assoc :float-value value))}]]

         [:div
          {:class "w-full h-full flex flex-1 flex-col gap-2 p-2"}
          [:label
           {:for :integer-with-multiplier}
           "Integer with multiplier"]
          [integer-input/view
           {:id         :integer-with-multiplier
            :value      int-value
            :multiplier multiplier
            :on-change  (fn [value]
                          (swap! state-atom assoc :int-value value))}]]

         [:div
          [text/p "Select multiplier"]
          (->> multiplier-options
               (map
                (fn [{:keys [value label]}]
                  ^{:key (str "multiplier-" value)}
                  [:div
                   {:class "mb-2"}
                   [:input
                    {:type      :radio
                     :name      :multiplier
                     :id        value
                     :value     value
                     :checked   (= value (:multiplier @state-atom))
                     :on-change (fn [e]
                                  (let [value (dg/event-target-value e)]
                                    (swap! state-atom assoc :multiplier value)))}]
                   [:label.ml-2
                    {:for value}
                    label]
                   ]))
               (doall))]

         ]))))


(defn percentage-input-view
  []
  (let [state-atom (r/atom {:value 1})]
    (fn []
      [:div
       [text/h2 "Percentage input"]

       [percentage-input/view
        {:value     (:value @state-atom)
         :on-change (fn [value]
                      (swap! state-atom assoc :value value))}]])))

(defn currency-input-view
  []
  (let [state-atom (r/atom {:currency-symbol :usd
                            :value           nil})]
    (fn []
      [:div
       [text/h2 "Currency input"]
       [:div.mb-2]
       [currency-input/view
        {:value           (:value @state-atom)
         :on-change       (fn [value]
                            (swap! state-atom assoc :value value))
         :secondary-props {:value     (:currency-symbol @state-atom)
                           :on-change (fn [value]
                                        (js/console.log "Secondary value : " value)
                                        (swap! state-atom assoc :currency-symbol value))}}]])))

(defn view
  []
  (r/create-class
   {:component-did-mount    (fn []
                              (let [int-value (random-int)
                                    float-value (random-float)]
                                (rf/dispatch [::event/init
                                              {:float-value  float-value
                                               :int-value    int-value
                                               :min-decimals 0
                                               :max-decimals 2}])))
    :component-will-unmount (fn []
                              (rf/dispatch [::event/cleanup]))
    :reagent-render
    (fn []
      (let [integer-value @(rf/subscribe [::sub/integer-value])
            float-value @(rf/subscribe [::sub/float-value])
            min-decimals @(rf/subscribe [::sub/min-decimals])
            max-decimals @(rf/subscribe [::sub/max-decimals])]

        [:div
         {:class "flex flex-col flex-1 gap-2 w-full h-full"}
         [text/h1 {} "Number input"]

         [:div
          {:style {:display        "flex"
                   :flex-direction "column"
                   :gap            "20px"}}

          [:div
           {:style {:display        "flex"
                    :flex-direction "column"}}
           [:label
            {:for :integer-input}
            "Integer"]
           [integer-input/view
            {:id        :integer-input
             :value     integer-value
             :on-blur   (fn [value]
                          (rf/dispatch-sync [::event/on-change-integer value]))
             :on-change (fn [value]
                          (rf/dispatch-sync [::event/on-change-integer value]))}]]

          [:div
           {:style {:display        "flex"
                    :flex-direction "column"}}
           [:label
            {:for :decimal-input}
            "Decimal number"]
           [number-input/view
            {:id           :decimal-input
             :value        float-value
             :min-decimals min-decimals
             :max-decimals max-decimals
             :on-blur      (fn [value]
                             (rf/dispatch-sync [::event/on-change-float value]))
             :on-change    (fn [value]
                             (rf/dispatch-sync [::event/on-change-float value]))}]]

          [:div
           [external-change-simulation]]

          [:div
           [min-max-decimals]]

          [:div
           [different-multiplier]]

          [:div
           [percentage-input-view]]

          [:div
           [currency-input-view]]

          ]]))}))
